import { withStyles } from '@material-ui/core/styles';
import { variables } from 'components/Theme';

export default withStyles((theme) => ({
  root: {},
  tabsIndicator: {
    height: '100%',
    zIndex: 1,
    borderRadius: '4px 4px 0 0',
  },
  scrollButton: {
    [theme.breakpoints.up(1490)]: {
      display: 'none',
    },
  },
  tabRoot: {
    color: '#818B9D',
    opacity: 1,
  },
  '&:focus': {
    color: '#192542',
  },
  '&$tabSelected': {
    color: '#192542',
    fontWeight: 500,
    boxShadow: theme.shadows[1],
  },
  tabSelected: {},
  label: {
    position: 'relative',
    zIndex: 2,
    fontSize: 16,
  },
  search: {
    [theme.breakpoints.up('md')]: {
      marginTop: '-66px',
    },
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  searchInput: {
    marginTop: `- ${theme.spacing(2)}px`,
    [theme.breakpoints.down('sm')]: {
      marginTop: 0,
    },
  },
  tableContainer: {
    marginTop: theme.spacing(2),
  },
  productAffiliations: {
    position: 'relative',
    padding: 10,
  },
  productStatus: {
    width: 5,
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    borderRadius: '4px 0 0 4px',
    background: '#ccc',
    '&.--active': {
      backgroundColor: variables.palette.secondary.main,
    },
    [theme.breakpoints.down('sm')]: {
      width: 16,
      height: 16,
      left: 8,
      borderRadius: '100%',
      top: 'auto',
    },
  },
  options: {
    width: '100px',
    '& > span > svg': {
      width: 24,
      height: 'auto',
      cursor: 'pointer',
    },
    '& > span > svg > path': {
      fill: variables.palette.primary.light,
    },
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
      '& span': {
        margin: '0 auto',
      },
    },
  },
  modalRecruit: {
    padding: '1.5rem',
    width: '95vw',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 10,
    background: '#fff',
    borderRadius: 4,
    [theme.breakpoints.up('md')]: {
      width: 640,
    },
  },
  modalRecruitTitle: {
    width: '100%',
    fontWeight: 500,
    fontSize: '20px',
    '& span': {
      display: 'block',
      fontWeight: 400,
      fontSize: '15px',
      marginTop: 15,
    },
  },
  modalRecruitHelperText: {
    width: '100%',
    fontSize: 12,
    color: '#666',
  },
  modalRecruitCancel: {
    textAlign: 'right',
    width: '100%',
  },
  titleAffiliations: {
    padding: '15px 0',
  },
  cancelAffiliation: {
    color: variables.palette.error.main,
  },
  list__moderation_status: {
    fontWeight: 400,
  },
  list__moderation_status__disapproved: {
    color: '#dc3f53',
  },
  list__moderation_status__approved: {
    color: '#009358',
  },
  list__moderation_status__moderation: {
    color: '#4159AD',
  },
  list__moderation_status__watzz: {
    color: 'yellow',
    textTransform: 'uppercase',
    fontWeight: 400,
  },
  title: {
    padding: '16px 8px',
    [theme.breakpoints.down('sm')]: {
      padding: '0 8px',
    },
  },
  colorStatusAffiliation: {
    '&.Pendente': {
      color: '#fabb0a',
    },
    '&.Aprovado': {
      color: 'green',
    },
    '&.Reprovado': {
      color: variables.palette.error.main,
    },
    '&.Cancelado': {
      color: variables.palette.error.main,
    },
    '&.Removido': {
      color: variables.palette.error.main,
    },
  },
}));
